export default "__VITE_ASSET__Cew8iUlt__"